import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {userProfile} from '@netx/core-user/collections/singletons/userProfile';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {UserPref} from '../constants';

export const isPublicUser = () => {
	const publicUserLogin = getPublicProperty(UserPref.PUBLIC_USER_LOGIN);
	return (
		isBrandPortal() &&
		publicUserLogin != null &&
		publicUserLogin === userProfile.get('login')
	);
};

export default isPublicUser;
